
import React from "react";
import {
    Typography,
    Paper,
    Box,
    Grid,
    useTheme,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from '@mui/x-data-grid';

import { tokens } from "../../theme";

import styles from './open-prods.module.css'

import { useState, useEffect } from 'react'
import { useSelector } from "react-redux";
import { selectIsStaffUser } from "../../store/user/user.selector";

const ProductTable = ({ groupedData, canShowPage }) => {
    const [totalProds, setTotalProds] = useState(0);
    const [totalProdsQuant, setTotalProdsQuant] = useState(0);

    const isStaff = useSelector(selectIsStaffUser);

    useEffect(() => {
        let totalValue = 0
        let totalQuant = 0
        Object.entries(groupedData).map(([model, items]) => {
            const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
            totalQuant += totalQuantity
            const totalValueProds = items.reduce(
                (sum, item) => sum + item.quantity * item.sell_price,
                0
            );
            totalValue += totalValueProds
        }, []);

        setTotalProds(totalValue)
        setTotalProdsQuant(totalQuant)
    }, [])

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    function formatToBrazilianDate(dateString) {
        if (!dateString) return '-'
        return new Date(dateString).toLocaleDateString('pt-BR');
    }

    const formatNumber = (data, digits) => {
        return data.toLocaleString("pt-br", {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    };

    return (

        <Box sx={{ width: "100%", minWidth: "800px" }}>
            <Accordion
                elevation={3}
                sx={{
                    marginBottom: 1,
                    backgroundColor: colors.pink[800],
                }}
            >
                <AccordionSummary disabled
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-geral}`}
                    id={`panel-geral-header`}
                >
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item sx={{ flexBasis: "300px" }}>
                            <Typography variant="h6">Geral</Typography>
                        </Grid>
                        <Grid item sx={{ flexBasis: "200px", textAlign: "right" }}>
                            <Typography variant="body1">
                                {formatNumber(totalProdsQuant, 0)} unidades
                            </Typography>
                        </Grid>
                        {
                            canShowPage &&
                            <Grid item sx={{ flexBasis: "200px", textAlign: "right" }}>
                                <Typography variant="body1">
                                    R$ {formatNumber(totalProds, 2)}
                                </Typography>
                            </Grid>
                        }
                    </Grid>
                </AccordionSummary>
            </Accordion>
            {Object.entries(groupedData).map(([model, items]) => {
                const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
                const totalValue = items.reduce(
                    (sum, item) => sum + item.quantity * item.sell_price,
                    0
                );

                return (
                    <Accordion
                        key={model}
                        elevation={3}
                        sx={{
                            marginBottom: 1,
                            backgroundColor: colors.pink[800],
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel-${model}`}
                            id={`panel-${model}-header`}
                        >
                            <Grid container alignItems="center" spacing={2}>
                                <Grid item sx={{ flexBasis: "300px" }}>
                                    <Typography variant="h6">{model.toUpperCase()}</Typography>
                                </Grid>
                                <Grid item sx={{ flexBasis: "200px", textAlign: "right" }}>
                                    <Typography variant="body1">
                                        {formatNumber(totalQuantity, 0)} Unidade
                                        {totalQuantity > 1 && "s"}
                                    </Typography>
                                </Grid>
                                {
                                    canShowPage &&
                                    <Grid item sx={{ flexBasis: "200px", textAlign: "right" }}>
                                        <Typography variant="body1">
                                            R$ {formatNumber(totalValue, 2)}
                                        </Typography>
                                    </Grid>
                                }
                            </Grid>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Paper sx={{ backgroundColor: colors.pink[700], marginTop: 2 }}>
                                <DataGrid
                                    rows={items} // Assuming `items` is your data array
                                    columns={[
                                        { field: 'product_id_produto', headerName: 'Produto', width: 150, headerClassName: styles['custom-header-bg'] },
                                        { field: 'product_tamanho', headerName: 'Tamanho', width: 150, valueFormatter: ({ value }) => value ? value : ' - ', headerClassName: styles['custom-header-bg'] },
                                        { field: 'kit__seller__nome', headerName: 'Vendedora', width: 250, headerClassName: styles['custom-header-bg'] },
                                        { field: 'quantity', headerName: 'Quantidade', width: 150, headerClassName: styles['custom-header-bg'] },
                                        { field: 'sell_price', headerName: 'Preço de Venda', width: 150, valueFormatter: ({ value }) => `R$ ${formatNumber(value, 2)}`, headerClassName: styles['custom-header-bg'] },
                                        { field: 'kit__pay_date', headerName: 'Data Acerto', width: 150, valueFormatter: ({ value }) => `${formatToBrazilianDate(value)}`, headerClassName: styles['custom-header-bg'] }
                                    ]}
                                    pageSize={10} // Customize the number of rows per page
                                    rowsPerPageOptions={[20, 50, 70]}
                                    autoHeight={true} // Adjusts grid height based on data
                                    getRowId={(row) => row.pk} // Ensure a unique ID is provided
                                />
                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </Box>
    );
};

export default ProductTable;